import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom'
import { Cookies } from 'react-cookie';
import Header from "./components/Layout/Header";
import Sidebar2 from './components/Layout/Sidebar';
import { ClearSession } from "./components/Common/Common";
const cookies = new Cookies();
const Protected = (Props) => {
    const { Component, open, setOpen, PageUrl } = Props;
    const navigate = useNavigate();
    const [auth, setAuth] = useState(false);
    const checkLogin = async () => {
        const Token = await cookies.get('token');
        const LoginUserCode = await cookies.get('loginUserCode');
        if (!Token) {
            const cookies = new Cookies();
            cookies.remove('token')
            cookies.remove('loginUserCode')
            cookies.remove('userName')
            navigate('/login')
        }
        else {
            const data = {
                Token: Token,
                LoginUserCode: LoginUserCode,
                PageUrl : PageUrl,
            }
            await fetch('/api/User/ValidateUserPageAccess', {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }
            ).then(async (response) => {
                let res = await response.json();
                if (res.status === "SUCCESS") {
                    setAuth(true);
                }
                else {
                    const cookies = new Cookies();
                    cookies.remove('token')
                    cookies.remove('loginUserCode')
                    cookies.remove('userName')
                    navigate('/login')
                   
                }
            }).catch((err) => {
                const cookies = new Cookies();
                cookies.remove('token')
                cookies.remove('loginUserCode')
                cookies.remove('userName')
                navigate('/login')
            })
        }

    };

    useEffect(() => {
        checkLogin();
    }, [])
  

    return auth ? (
        <>
            <Header setOpen={setOpen} open={open} />
            <Sidebar2 open={open} setOpen={setOpen} />
            <Component open={open} />
        </>
    ) : <></>
}
export default Protected